import { useGoogleMap } from '@react-google-maps/api';
import React from 'react';

import { StyledLocateIcon } from './styles';
import { ControlPaper } from '../styles';
import { LocateControlProps } from './types';

const LocateControl: React.FunctionComponent<LocateControlProps> = ({
  location,
  ...props
}): React.ReactElement | null => {
  const map = useGoogleMap();

  const center = (): void => {
    map?.panTo(location);
  };

  if (!map) {
    return null;
  }

  return (
    <ControlPaper elevation={6} {...props}>
      <StyledLocateIcon onClick={center} />
    </ControlPaper>
  );
};

export default LocateControl;
